<template>
    <div>
        <div class="card-header bg-transparent border-bottom-0">
            <div class="row">
                <div class="col-12 col-md-12 col-lg-4 col-xl-4">
                    <b-form-group label-for="tracking-code" label="หมายเลขพัสดุ" class="mb-0">
                        <b-input-group>
                            <b-input-group-prepend is-text>
                                <i class="fa fa-search text-muted"></i>
                            </b-input-group-prepend>
                            <b-form-input 
                                id="tracking-code" 
                                type="search" 
                                required 
                                placeholder="ค้นหาด้วยหมายเลขพัสดุ"
                                v-model="search.courierTrackingCode"
                            >
                            </b-form-input>
                        </b-input-group>
                    </b-form-group>
                </div>     
                <div class="col-6 col-md-6 col-lg-4 col-xl-5">
                    <label>ประเภทของปัญหา</label>
                    <v-select    
                        label="category_name"
                        v-model="search.categoryId"
                        :options="reportParcel.category"
                        :reduce="typeErrorParcel => typeErrorParcel.id"
                    >
                    </v-select>
                </div>            
                <div class="col-4 col-md-4 col-lg-2 col-xl-2 d-flex align-items-end">
                    <b-button 
                        variant="primary" 
                        block
                        @click="getReportShipmentPending"
                    >
                        <i class="fas fa-circle-notch fa-spin" v-if="search.isLoadSearch"></i>
                        ค้นหา
                    </b-button>
                </div>
                <div class="col-2 col-md-2 col-lg-2 col-xl-1 d-flex align-items-end">
                    <b-button   
                        variant="primary"
                        class="rounded-circle"
                        :class="search.collapseSearch ? null : 'collapsed'"
                        :aria-expanded="search.collapseSearch ? true : false"
                        aria-controls="collapseSearchParcel"
                        @click="search.collapseSearch = !search.collapseSearch"
                    >
                        <i class="fas fa-angle-double-up" v-if="search.collapseSearch"></i>
                        <i class="fas fa-angle-double-down" v-else></i>
                    </b-button>
                </div>    
            </div>
        </div>
        <div class="card-header bg-transparent border-bottom-0">
            <div class="text-warning">
                รายการที่มีการตอบกลับหลังเวลา 17.30 น.เจ้าหน้าที่จะดำเนินการประสานงานขนส่งในรอบของวันถัดไป<br>
                หากต้องการแจ้งเรื่องโดยตรง สามารถติดต่อแอดมินได้ที่ LINE ID: @POPSHIPPOP<br>
                <b class="font-weight-bold">กรุณาเลือกใช้เพียงหนึ่งช่องทางในการติดต่อ เพื่อป้องกันความซ้ำซ้อนในการประสานงาน</b>
            </div>
        </div>
    </div>
</template>

<script>
import { getShipmentPending , getShipmentPendingCategory } from "@/axios/failReport.js";

export default {
    props:{
        reportParcel: Object,
        search: Object
    },
    mounted(){
        this.getReportShipmentPending();
        this.getReportShipmentPendingCetegory();
    },
    methods:{
        async getReportShipmentPending(){
            this.search.isLoadSearch = true;
            await getShipmentPending( this.search ).then( res => {
                this.search.isLoadSearch = false;
                this.reportParcel.items = res;
            }).catch(error => {
                this.search.isLoadSearch = false;
            });
        },
        async getReportShipmentPendingCetegory(){
            await getShipmentPendingCategory().then( res => {
                this.reportParcel.category.push.apply( this.reportParcel.category , res );
                console.log( this.reportParcel.category )
                this.reportParcel.busy = false
            }).catch(error => {
                this.reportParcel.busy = false
            });
        }
    }
   
}
</script>
